import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "common";
export const initialState = {
    location: undefined,
    sessionChanges: false,
    isLogOut: false,
    isLeaveFormFilled: null,
    modal: false,
    selectedPrice: 35,
    prices: {
        adviceChat: "",
        adviceVideo: "",
        rxVideo: ""
    },
};

const commonReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setLocation: (state, action) => ({
            ...state,
            location: action.payload
        }),
        setChangesForSession: (state, action) => ({
            ...state,
            sessionChanges: action.payload,
        }),
        setIsLogOut: (state, action) => ({
            ...state,
            isLogOut: action.payload
        }),
        setUserInfo: (state, action) => ({
            ...state,
            isLeaveFormFilled: action.payload
        }),
        setModal: (state, action) => ({
            ...state,
            modal: action.payload
        }),
        setSelectedPrice: (state, action) => ({
            ...state,
            selectedPrice: action.payload
        }),
        setClientPrices: (state, action) => ({
            ...state,
            prices: {
                adviceChat: (Number(action.payload[0].price.split(" ")[1]) + 5).toFixed(action.payload[0].price.split(".")[1] === "00" ? 0 : 2).toString(),
                adviceVideo: (Number(action.payload[1].price.split(" ")[1]) + 5).toFixed(action.payload[1].price.split(".")[1] === "00" ? 0 : 2).toString(),
                rxVideo: (Number(action.payload[2].price.split(" ")[1]) + 5).toFixed(action.payload[2].price.split(".")[1] === "00" ? 0 : 2).toString(),
            }
        })
    }
});

export default commonReducer.reducer;
export const {
    setLocation,
    setIsLogOut, setUserInfo,
    setModal,
    setSelectedPrice,
    setClientPrices,
    setChangesForSession,
} = commonReducer.actions;

